export const FETCHING_SL_GROUPS_INITIAL_DATA = 'FETCHING_SL_GROUPS_INITIAL_DATA';
export const FETCHING_SL_GROUPS_INITIAL_DATA_SUCCESS = 'FETCHING_SL_GROUPS_INITIAL_DATA_SUCCESS';
export const FETCHING_SL_GROUPS_INITIAL_DATA_FAILURE = 'FETCHING_SL_GROUPS_INITIAL_DATA_FAILURE';

export const FETCHING_SL_GROUP_ITEMS = 'FETCHING_SL_GROUP_ITEMS';
export const FETCHING_SL_GROUP_ITEMS_SUCCESS = 'FETCHING_SL_GROUP_ITEMS_SUCCESS';
export const FETCHING_SL_GROUP_ITEMS_FAILURE = 'FETCHING_SL_GROUP_ITEMS_FAILURE';

export const CHANGE_SL_GROUP_TYPE = 'CHANGE_SL_GROUP_TYPE';
export const CHANGE_SL_GROUP_ITEM = 'CHANGE_SL_GROUP_ITEM';

export const CHANGE_PERIOD_FROM = 'CHANGE_PERIOD_FROM';
export const CHANGE_PERIOD_TO = 'CHANGE_PERIOD_TO';

export const FETCHING_COUNTRY_TAX_TYPES = 'FETCHING_COUNTRY_TAX_TYPES';
export const FETCHING_COUNTRY_TAX_TYPES_SUCCESS = 'FETCHING_COUNTRY_TAX_TYPES_SUCCESS';
export const FETCHING_COUNTRY_TAX_TYPES_FAILURE = 'FETCHING_COUNTRY_TAX_TYPES_FAILURE';

export const CHANGE_COUNTRY_TAX_TYPE = 'CHANGE_COUNTRY_TAX_TYPE';

export const FETCHING_REPORT_DATA_FOR_GROUP = 'FETCHING_REPORT_DATA_FOR_GROUP';
export const FETCHING_REPORT_DATA_FOR_GROUP_SUCCESS = 'FETCHING_REPORT_DATA_FOR_GROUP_SUCCESS';
export const FETCHING_REPORT_DATA_FOR_GROUP_FAILURE = 'FETCHING_REPORT_DATA_FOR_GROUP_FAILURE';

export const CHANGE_BOOK_TYPE = 'CHANGE_BOOK_TYPE';

export const FETCHING_REPORTING_CURRENCY_CODES_FOR_GROUP = 'FETCHING_REPORTING_CURRENCY_CODES_FOR_GROUP';
export const FETCHING_REPORTING_CURRENCY_CODES_FOR_GROUP_SUCCESS = 'FETCHING_REPORTING_CURRENCY_CODES_FOR_GROUP_SUCCESS';
export const FETCHING_REPORTING_CURRENCY_CODES_FOR_GROUP_FAILURE = 'FETCHING_REPORTING_CURRENCY_CODES_FOR_GROUP_FAILURE';

export const FETCH_TBE_ERRORS = 'FETCH_TBE_ERRORS';
